import { render, staticRenderFns } from "./CardsList.vue?vue&type=template&id=290ac5a0&scoped=true"
import script from "./CardsList.vue?vue&type=script&lang=js"
export * from "./CardsList.vue?vue&type=script&lang=js"
import style0 from "./CardsList.vue?vue&type=style&index=0&id=290ac5a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290ac5a0",
  null
  
)

export default component.exports